import React from 'react';
import { Box, BoxProps, CSSObject, Icon, StackProps } from '@chakra-ui/react';
import { CheckmarkOutline, CloseOutline } from 'styled-icons/evaicons-outline';
import {
  TPasswordRule,
  TPasswordRulesIcon,
  TPasswordTooltip,
} from '../services/SignUp.types';
import { CustomButtonProps } from '@/components/Button/Button';
import { SignUpSchema } from './SignUp.styles';

export const SignUpDatePicker: CSSObject = {
  zIndex: 'popover',
};

export const FlexHeaderWrapper: CSSObject = {
  color: 'beta.300',
  fontSize: 'lg',
  fontStyle: 'normal',
  fontFamily: 'heading',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  mb: '4',
  gap: '5px',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
};

export const signUpStyles: SignUpSchema = {
  buttonSignUp: {
    color: 'blackAlpha.700',
    bgGradient: 'linear(to-b, beta.300, beta.500)',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: 'xs',
  },
};

export const FormStack = (props: StackProps) => (
  <Box
    {...props}
    display={['unset', null, 'flex']}
    gap={['unset', null, '2']}
  />
);

export const SignUpInput: CSSObject = {
  borderRadius: 'base',
};

export const addressWrapperProps: BoxProps = {
  sx: {
    '& .chakra-form-control': {
      mb: '2',
    },
  },
  mb: '4',
};

export const SignupAcknowledgementButton: CSSObject = {
  color: 'beta.300',
  fontWeight: 'bold',
  textDecoration: 'none',
};

export const BoxLoginCTAContainer: CSSObject = {
  display: 'none',
};

export const SignUpButton: CustomButtonProps = {
  variant: 'unstyled',
  mb: '0',
  w: 'full',
  color: 'blackAlpha.800',
  bgGradient: 'linear(to-b, beta.200, beta.500)',
  fontSize: 'xs',
  borderRadius: 'md',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  _hover: {
    opacity: 0.9,
  },
};

export const BoxManualAddressContainer: CSSObject = {
  p: '4',
  pb: '0',
  border: '1px dashed',
  borderColor: 'gray.300',
  borderRadius: 'base',
};

export const CheckboxHelpText: CSSObject = {
  color: 'white',
  fontFamily: 'accent',
  button: {
    h: 'unset',
  },
};

export const PasswordTooltip = ({
  validPassword,
}: TPasswordTooltip): CSSObject => ({
  bg: validPassword ? 'gamma.100' : 'red.500',
  borderRadius: 'md',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.20)',
  color: validPassword ? 'alpha.700' : 'white',
  '.chakra-tooltip__arrow': {
    // ! Importants are needed to override tooltip's inline styles
    bg: validPassword
      ? 'var(--bc-colors-gamma-100) !important'
      : 'var(--bc-colors-red-500) !important',
  },
});

export const PasswordRule = ({ active }: TPasswordRule): CSSObject => ({
  fontWeight: 'semibold',
  opacity: '1',
  color: active ? 'alpha.700' : 'white',
});

export const PasswordRulesIcon = ({ active }: TPasswordRulesIcon) => (
  <Icon as={active ? CheckmarkOutline : CloseOutline} boxSize="4" mr="0.5" />
);
